// extracted by mini-css-extract-plugin
export default {"bottomcon":"dashboard_bottomcon__qpYKO","boxcontainer":"dashboard_boxcontainer__DueYl"};